import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const HeaderArea = ({
  leftArea,
  centerArea,
  rightArea,
  columnDirectionToMobileScreen,
}) => (
  <Container columnDirectionToMobileScreen={columnDirectionToMobileScreen}>
    {leftArea}
    {centerArea}
    {rightArea}
  </Container>
);

HeaderArea.defaultProps = {
  leftArea: null,
  centerArea: null,
  rightArea: null,
  columnDirectionToMobileScreen: false,
};

HeaderArea.propTypes = {
  columnDirectionToMobileScreen: PropTypes.bool,
  leftArea: PropTypes.node,
  centerArea: PropTypes.node,
  rightArea: PropTypes.node,
};

export default HeaderArea;
